<template>
  <div>
    <!-- <tci-video class="d-none d-sm-flex"></tci-video> -->
    <div class="d-none d-sm-flex">
      <v-carousel v-if="$i18n.locale=='zh'" :interval="5000" cycle transition="slide">
        <v-carousel-item
            v-for="(item,i) in carousels"
            :key='"carousel-item-c-"+i'
            :src="item"
          ></v-carousel-item>
      </v-carousel>
    <v-carousel v-else :interval="5000" cycle transition="slide">
        <v-carousel-item
          v-for="(item,i) in carousels_ja"
          :key='"carousel-item-j-"+i'
          :src="item"
        ></v-carousel-item>
    </v-carousel>
    </div>
    <v-img src="../assets/home_mobile.jpg" height=400  class="d-flex d-sm-none">
      <v-row class="fill-height white--text text-center"  align-content="center" no-gutters>
        <v-col class="title px-8" cols=12>Global Digital</v-col>
        <v-col class="title px-8" cols=12>Transformation Partner</v-col>
        <v-col class="title px-8" cols=12>{{ $t('home.content') }}</v-col>
      </v-row>
    </v-img>
    <tci-title :title="$t('about.about')" subtitle="ABOUT US">
      <v-row>
        <tci-pic-div
          :title="$t('overview.title')"
          subtitle="OVERVIEW"
          jumpTo="/company-overview"
          :imgSrc="require('../assets/2-1.jpg')"
        ></tci-pic-div>
        <tci-pic-div
          :title="$t('corporate_vision.title')"
          subtitle="CORPORATE VISION"
          jumpTo="/company-vision"
          :imgSrc="require('../assets/2-2.jpg')"
        ></tci-pic-div>
      </v-row>
      <v-row>
       <tci-pic-div
          :title="$t('history.title')"
          subtitle="HISTORY"
          jumpTo="/company-history"
          :imgSrc="require('../assets/2-3.jpg')"
        ></tci-pic-div>
        <tci-pic-div
          :title="$t('organization.title')"
          subtitle="ORGANIZATION"
          jumpTo="/company-organization"
          :imgSrc="require('../assets/2-4.jpg')"
        ></tci-pic-div>
      </v-row>
    </tci-title>
    <tci-title :title="$t('service.title')" subtitle="SERVICE" color="grey lighten-4">
      <v-row>
        <tci-pic-div
            :title="$t('service_dev.title')"
            :subtitle="$t('service_dev.subtitle')"
            jumpTo="/service"
            :imgSrc="require('../assets/3-1.jpg')"
            font_title="white--text title"
            font_subtitle="white--text subtitle-1"
          ></tci-pic-div>
          <tci-pic-div
            :title="$t('service_support.title')"
            :subtitle="$t('service_support.subtitle')"
            jumpTo="/service"
            :imgSrc="require('../assets/3-2.jpg')"
            font_title="white--text title"
            font_subtitle="white--text subtitle-1"
          ></tci-pic-div>
      </v-row>
      <v-row class="text-center" align="center">
        <v-spacer></v-spacer>
        <v-col>
          <v-card class="mt-12" height="300" flat tile color="transparent">
            <!--<v-card-title class="font-weight-regular text-no-wrap justify-center" v-html="$t('service.content')">{{ $t('service.content') }}</v-card-title>-->
            <!-- 手机端 -->
            <v-card-title class="d-sm-none caption font-weight-regular text-no-wrap justify-center" v-html="$t('service.content')">{{ $t('service.content') }}</v-card-title>
            <!-- 非手机端 -->
            <v-card-title class="d-none d-sm-flex font-weight-regular text-no-wrap justify-center" v-html="$t('service.content')">{{ $t('service.content') }}</v-card-title>
            <v-card-actions>
              <v-row justify="center">
                <v-btn to="/service" color="#0F1D2D" width=300 height=50 x-large class="mt-6 white--text" elevation=24 tile>{{ $t('service.detailBtn') }}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </tci-title>
    <tci-title :title="$t('solution.title')" subtitle="SOLUTION">
        <v-row>
          <!--<v-spacer class="d-none d-sm-flex"></v-spacer>-->
          <v-col>
            <v-card tile class="pt-2" :height='$i18n.locale=="zh"?"":""' >
                <v-row justify="center" class="mx-2">
                 <v-img :aspect-ratio="16/9" width="320" src="../assets/4-1.jpg" gradient="to top right, rgba(13,11,10,.33),rgba(13,11,10,.7)">
                    <v-row>
                      <v-card-text class="white--text text-right text-end">MES</v-card-text>
                    </v-row>
                  </v-img>
                </v-row>
                <v-card-text>{{ $t('solution.content1') }}</v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card tile class="pt-2" :height='$i18n.locale=="zh"?"":""'>
              <v-row justify="center" class="mx-2">
                <v-img :aspect-ratio="16/9" width="320"  src="../assets/4-2.jpg" gradient="to top right, rgba(13,11,10,.33),rgba(13,11,10,.7)">
                  <v-card-text class="white--text text-end text-right pb-0">CRM</v-card-text>
                  <v-card-text class="white--text text-end text-right py-0">AI</v-card-text>
                  <v-card-text class="white--text text-end text-right py-0">IoT</v-card-text>
                  <v-card-text class="white--text text-end text-right py-0">RPA</v-card-text>
                </v-img>
              </v-row>
              <v-card-text>{{ $t('solution.content2') }}</v-card-text>
            </v-card>
          </v-col>
          <!--<v-spacer class="d-none d-sm-flex"></v-spacer> -->
        </v-row>
        <v-row justify="center" align="center" class="py-12">
          <v-btn to="/solution" color="#0F1D2D" width=300 height=50 x-large class=" white--text" elevation=24 tile>{{ $t('service.detailBtn') }}</v-btn>
        </v-row>
    </tci-title>
    <tci-title :title="$t('news.title')" subtitle="NEWS" color="grey lighten-4">
      <v-row v-for="item in langNews" :key="item.title">
        <v-spacer></v-spacer>
          <tci-news-div :imgSrc="item.imgUrl" :title="item.title" :content="item.content" :newsDate="item.newsDate" :jumpTo="item.jumpTo"></tci-news-div>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" class="py-12">
        <v-btn to="/company-news" color="#0F1D2D" width=300 height=50 x-large class=" white--text" elevation=24 tile>{{ $t('service.detailBtn') }}</v-btn>
      </v-row>
    </tci-title>

    <tci-title :title="$t('recruit.title')" subtitle="RECRUIT" v-scroll="onScroll">
      <v-row>
      <!--非手机端-->
      <v-img src="../assets/family.jpg" class="ma-0 pa-0 d-none d-lg-flex" height=500 ref="parallaxy_div">
      <v-row class="fill-height pa-0 ma-0" no-gutters >
        <v-col cols="3">
          <v-card class="auto-mx fill-height ma-0 pa-0" tile color="rgba(255, 255, 255, 0.7)" elevation=0>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="fill-height ma-0 pa-0" tile color="rgba(255, 255, 255, 0.7)" elevation=0>
            <v-row align-content="center" class="fill-height">
                <v-card-title class="display-2 grey--text">{{ $t('recruit.joinUs') }}</v-card-title>
                <v-card-text v-html="$t('recruit.content')">{{ $t('recruit.content') }}</v-card-text>
                <v-card-actions>
                  <v-btn color="error" to="recruit" depressed tile>{{ $t('recruit.joinButton') }}</v-btn>
                </v-card-actions>
            </v-row>
          </v-card>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="6"></v-col>
      </v-row>
      </v-img>
      <!--平板端-->
      <v-img src="../assets/family.jpg" class="ma-0 pa-0 d-none d-sm-flex d-lg-none" height=400>
        <v-row class="fill-height pa-0 ma-0" no-gutters>
          <v-col cols=6>
           <v-card tile class="fill-height" color="rgba(255, 255, 255, 0.7)" elevation=0>
          </v-card>
          </v-col>
          <v-col cols=6></v-col>
        </v-row>
        <v-overlay absolute color=transparent>
          <v-card class="fill-height ma-0 pa-0" tile color="transparent" width=200 elevation=0>
            <v-row align-content="center" class="fill-height">
                <v-card-title class="display-2 grey--text">{{ $t('recruit.joinUs') }}</v-card-title>
                <v-card-text class= "grey--text">{{ $t('recruit.content') }}</v-card-text>
                <v-row justify="center" align="center" class="py-12">
                  <v-card-actions>
                    <v-btn x-large width=200 class="title" color="error" to="recruit" depressed tile>{{ $t('recruit.joinButton') }}</v-btn>
                  </v-card-actions>
                </v-row>
            </v-row>
          </v-card>
        </v-overlay>
      </v-img>
      <!--手机端-->
      <v-img src="../assets/family.jpg" class="ma-0 pa-0 d-sm-none" height=400>
        <v-card tile class="pl-4" color="rgba(255, 255, 255, 0.7)" height=250 elevation=0>
          <v-row align-content="center" class="fill-height">
              <v-card-title class="display-2 grey--text">{{ $t('recruit.joinUs') }}</v-card-title>
              <v-card-text>{{ $t('recruit.content') }}</v-card-text>
              <v-card-actions>
                 <v-btn class="title" x-large width=160 color="error" to="recruit" depressed tile>{{ $t('recruit.joinButton') }}</v-btn>
             </v-card-actions>
          </v-row>
        </v-card>
      </v-img>
      </v-row>
    </tci-title>
    <tci-contact-footer color="grey lighten-2"></tci-contact-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import TciTitle from "@/components/TciTitle.vue";
import TciPicDiv from "@/components/TciPicDiv.vue";
import TciNewsDiv from "@/components/TciNewsDiv.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";
// import TciVideo from "@/components/TciVideo.vue";
import axios from "axios";
import i18n from '@/i18n';

export default {
  name: "Home",
  components: {
    "tci-title": TciTitle,
    "tci-pic-div": TciPicDiv,
    "tci-news-div": TciNewsDiv,
    "tci-contact-footer": TciContactFooter
    // "tci-video": TciVideo
  },
  methods: {
    onScroll: function () {
      this.$refs.parallaxy_div.$el.getElementsByClassName("v-image__image")[0].style["background-attachment"]="fixed"
    }
  },
  computed: {
    langNews: function() {
      return this.news.filter(function(item){
        if(i18n.locale=='zh'){
          return item.lang=='ZH'
        }else{
          return item.lang=='JP'
        }
      });
    }
  },
  mounted () {
      //http://47.97.198.129:8080/api/news/homePage 改成http://tciman.9ban.tech:8080/api/news/homePage改成http://47.114.149.15:8080/api/news/homePage
    axios
      .get('http://47.114.149.15:8080/api/news/homePage')
      .then(response => (this.news = response.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
  },
  data: () => ({
    news: [],
    carousels:[require('../assets/carousels/aps.png'),
      require('../assets/carousels/c_abc.jpg'),
    require('../assets/carousels/c_flu.jpg'),
    require('../assets/carousels/c_gcc.jpg'),
    require('../assets/carousels/c_lowcode.jpg'),
    require('../assets/carousels/c_rpa.jpg')],
    carousels_ja:[require('../assets/carousels/j_abc.jpg'),
    require('../assets/carousels/j_flu.jpg'),
    require('../assets/carousels/j_gcc.jpg'),
    require('../assets/carousels/j_lowcode.jpg'),
    require('../assets/carousels/j_rpa.jpg')]
  })
};
</script>
<style scoped>
.v-btn:hover:before {
  opacity: 0.4 !important;
}
</style>
